<script>
    import { NotificationModal } from "./index.svelte";

    export let isModalOpen = false,
        closeModal = () => {},
        confirmAction = () => {},
        isConfirming = false;
</script>

<NotificationModal
    {isModalOpen}
    cancelText="Not now"
    submitText={`${isConfirming ? "Confirming" : "Confirm"}`}
    {isConfirming}
    {closeModal}
    {confirmAction}
    closeModalFunction={closeModal}
>
    Un-set patient Bad Debtor recognised by Medicare Number
</NotificationModal>
